import React, { useState } from "react";
import styles from './exInvFileUploadPreview.module.css';
import TableComponent from '../../components/OtherComps/TableComponent/TableComponent'

const ExInvFileUploadPreview = () => {
  return (
    <>
      <div className={styles.imgBread}>
        <span>Excess Inventory</span>
      </div>
      <div className={styles.fileContainer}>
        <TableComponent />
      </div>
    </>
  )
}

export default ExInvFileUploadPreview